import { render, staticRenderFns } from "./ui-list-tag.vue?vue&type=template&id=bd679e22&scoped=true"
import script from "./ui-list-tag.vue?vue&type=script&lang=js"
export * from "./ui-list-tag.vue?vue&type=script&lang=js"
import style0 from "./ui-list-tag.vue?vue&type=style&index=0&id=bd679e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd679e22",
  null
  
)

export default component.exports